import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/cn";

const SETTINGS_SECTIONS = [
  { path: "/settings/ai", label: "AI" },
  { path: "/settings/prompts", label: "Prompts" },
  { path: "/settings/cli", label: "CLI" },
  { path: "/settings/providers", label: "Providers" },
  { path: "/settings/discovery", label: "Discovery" },
  { path: "/settings/plugins", label: "Plugins" },
] as const;

function isActive(sectionPath: string, currentPathname: string): boolean {
  if (sectionPath === "/settings/prompts" && currentPathname.startsWith("/settings/prompts")) return true;
  if (sectionPath === "/settings/providers" && currentPathname.startsWith("/settings/providers")) return true;
  if (sectionPath === "/settings/plugins" && currentPathname.startsWith("/settings/plugins")) return true;
  if (sectionPath === "/settings/ai" && currentPathname.startsWith("/settings/ai")) return true;
  if (sectionPath === "/settings/discovery" && currentPathname.startsWith("/settings/discovery")) return true;
  return currentPathname === sectionPath;
}

export function SettingsLayout() {
  const location = useLocation();

  return (
    <>
      <header className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-foreground">App settings</h1>
            <p className="text-muted-foreground">
              System configuration for AI, prompts, providers, and plugins.
              Profile and goals live under{" "}
              <Link to="/profile" className="text-brand hover:underline">
                Profile
              </Link>{" "}
              and{" "}
              <Link to="/goals" className="text-brand hover:underline">
                Goals
              </Link>
              .
            </p>
          </div>
        </div>
      </header>

      <div className="mb-6 flex gap-1 overflow-x-auto border-b border-border">
        {SETTINGS_SECTIONS.map((section) => (
          <Link
            key={section.path}
            to={section.path}
            className={cn(
              "relative whitespace-nowrap px-4 py-2.5 text-sm font-medium transition",
              isActive(section.path, location.pathname)
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {section.label}
            {isActive(section.path, location.pathname) && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand" />
            )}
          </Link>
        ))}
      </div>

      <Outlet />
    </>
  );
}
